// extracted by mini-css-extract-plugin
export var container = "breadcrumbs-module--container--Bi9vb";
export var linkItem = "breadcrumbs-module--link-item--d0hHP";
export var list = "breadcrumbs-module--list--Fed+v";